"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _format = _interopRequireDefault(require("date-fns/format"));
var _formatISO = _interopRequireDefault(require("date-fns/formatISO"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _pushDataLayer = _interopRequireDefault(require("@lumirental/lumi-web-sdk/dist/utils/gtm/pushDataLayer"));
var _get24hTime = _interopRequireDefault(require("../../get24hTime"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * When search button is clicked
 * @param {string} screenName
 * @param {object} pickupBranch
 * @param {object} dropoffBranch
 * @param {Date} pickupDate
 * @param {Date} dropoffDate
 * @param {string} pickupTime
 * @param {string} dropoffTime
 * @param {number} activeTabIndex
 * @param {boolean} isDropOffBranchSame
 */
function searchTapped(screenName, pickupBranch, dropoffBranch, pickupDate, dropoffDate, pickupTime, dropoffTime, activeTabIndex, isDropOffBranchSame) {
  var pickupBranchName = (0, _get2["default"])(pickupBranch, 'nameEn', '').toLowerCase();
  var dropoffBranchName = (0, _get2["default"])(dropoffBranch, 'nameEn', '').toLowerCase();
  var formattedPickupDate = (0, _formatISO["default"])(pickupDate);
  var formattedDropoffDate = (0, _formatISO["default"])(dropoffDate);
  var bookingType = (0, _get2["default"])(pickupBranch, 'carDelivery', false);

  // convert time in 24h format.
  var formatPickupTime = (0, _get24hTime["default"])(pickupTime);
  var formatDropoffTime = (0, _get24hTime["default"])(dropoffTime);
  var eventData = {
    event: 'search_tapped',
    screen_name: screenName,
    pickup_branch_name: pickupBranchName,
    dropoff_branch_name: dropoffBranchName,
    pickup_date: formattedPickupDate,
    dropoff_date: formattedDropoffDate,
    pickup_time: formatPickupTime,
    dropoff_time: formatDropoffTime,
    short_term: !activeTabIndex,
    dropoff_branch_different: !isDropOffBranchSame,
    booking_type: bookingType ? 'delivery' : 'pickup'
  };
  console.log('** gtm event search_tapped: ', eventData);
  (0, _pushDataLayer["default"])(eventData);
}
var _default = exports["default"] = searchTapped;